import type { Query as Query0 } from '../pages/banner/index.page'
import type { Query as Query1 } from '../pages/banner/fast-pass-reception/index.page'
import type { Query as Query2 } from '../pages/banner/reception/index.page'
import type { OptionalQuery as OptionalQuery3 } from '../pages/home/index.page'
import type { OptionalQuery as OptionalQuery4 } from '../pages/home/histories/index.page'
import type { Query as Query5 } from '../pages/home/standbys/index.page'

export const pagesPath = {
  "$404": {
    $url: (url?: { hash?: string }) => ({ pathname: '/404' as const, hash: url?.hash })
  },
  "banner": {
    _curonClinicId: (curonClinicId: string | number) => ({
      $url: (url?: { hash?: string }) => ({ pathname: '/banner/[curonClinicId]' as const, query: { curonClinicId }, hash: url?.hash })
    }),
    "fast_pass_reception": {
      $url: (url: { query: Query1, hash?: string }) => ({ pathname: '/banner/fast-pass-reception' as const, query: url.query, hash: url.hash })
    },
    "reception": {
      $url: (url: { query: Query2, hash?: string }) => ({ pathname: '/banner/reception' as const, query: url.query, hash: url.hash })
    },
    $url: (url: { query: Query0, hash?: string }) => ({ pathname: '/banner' as const, query: url.query, hash: url.hash })
  },
  "home": {
    "account": {
      $url: (url?: { hash?: string }) => ({ pathname: '/home/account' as const, hash: url?.hash })
    },
    "contact": {
      $url: (url?: { hash?: string }) => ({ pathname: '/home/contact' as const, hash: url?.hash })
    },
    "downloads": {
      "banners": {
        $url: (url?: { hash?: string }) => ({ pathname: '/home/downloads/banners' as const, hash: url?.hash })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/home/downloads' as const, hash: url?.hash })
    },
    "fast_pass_reception": {
      "downloads": {
        "banners": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/fast-pass-reception/downloads/banners' as const, hash: url?.hash })
        }
      },
      "setting": {
        $url: (url?: { hash?: string }) => ({ pathname: '/home/fast-pass-reception/setting' as const, hash: url?.hash })
      }
    },
    "histories": {
      $url: (url?: { query?: OptionalQuery4, hash?: string }) => ({ pathname: '/home/histories' as const, query: url?.query, hash: url?.hash })
    },
    "notification_setting": {
      "ipad_pwa": {
        "confirm_current_setting": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/notification-setting/ipad-pwa/confirm-current-setting' as const, hash: url?.hash })
        },
        "install": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/notification-setting/ipad-pwa/install' as const, hash: url?.hash })
        }
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/home/notification-setting' as const, hash: url?.hash })
    },
    "optional_settings": {
      $url: (url?: { hash?: string }) => ({ pathname: '/home/optional-settings' as const, hash: url?.hash })
    },
    "orca": {
      "visits": {
        _visitId: (visitId: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/home/orca/visits/[visitId]' as const, query: { visitId }, hash: url?.hash })
        })
      }
    },
    "patients": {
      _patientId: (patientId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/home/patients/[patientId]' as const, query: { patientId }, hash: url?.hash })
      }),
      $url: (url?: { hash?: string }) => ({ pathname: '/home/patients' as const, hash: url?.hash })
    },
    "quick_pass": {
      _sessionId: (sessionId: string | number) => ({
        "confirm": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/quick-pass/[sessionId]/confirm' as const, query: { sessionId }, hash: url?.hash })
        },
        "preview": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/quick-pass/[sessionId]/preview' as const, query: { sessionId }, hash: url?.hash })
        }
      })
    },
    "reception": {
      "downloads": {
        "banners": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/downloads/banners' as const, hash: url?.hash })
        }
      },
      "guide": {
        $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/guide' as const, hash: url?.hash })
      },
      "menus": {
        _menuId: (menuId: string | number) => ({
          "edit": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/menus/[menuId]/edit' as const, query: { menuId }, hash: url?.hash })
          }
        }),
        "new": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/menus/new' as const, hash: url?.hash })
        }
      },
      "optional_settings": {
        _token: (token: string | number) => ({
          $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/optional-settings/[token]' as const, query: { token }, hash: url?.hash })
        })
      },
      "setting": {
        "edit": {
          "absence": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/setting/edit/absence' as const, hash: url?.hash })
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/setting/edit' as const, hash: url?.hash })
        },
        "new": {
          "absence": {
            $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/setting/new/absence' as const, hash: url?.hash })
          },
          $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/setting/new' as const, hash: url?.hash })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/home/reception/setting' as const, hash: url?.hash })
      },
      $url: (url?: { hash?: string }) => ({ pathname: '/home/reception' as const, hash: url?.hash })
    },
    "standbys": {
      _standbyId: (standbyId: string | number) => ({
        $url: (url?: { hash?: string }) => ({ pathname: '/home/standbys/[standbyId]' as const, query: { standbyId }, hash: url?.hash })
      }),
      $url: (url: { query: Query5, hash?: string }) => ({ pathname: '/home/standbys' as const, query: url.query, hash: url.hash })
    },
    "switch_clinic": {
      $url: (url?: { hash?: string }) => ({ pathname: '/home/switch-clinic' as const, hash: url?.hash })
    },
    "visits": {
      _visitId: (visitId: string | number) => ({
        "cancel": {
          $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]/cancel' as const, query: { visitId }, hash: url?.hash })
        },
        $url: (url?: { hash?: string }) => ({ pathname: '/home/visits/[visitId]' as const, query: { visitId }, hash: url?.hash })
      })
    },
    $url: (url?: { query?: OptionalQuery3, hash?: string }) => ({ pathname: '/home' as const, query: url?.query, hash: url?.hash })
  },
  "reception": {
    _clinicId: (clinicId: string | number) => ({
      "status": {
        $url: (url?: { hash?: string }) => ({ pathname: '/reception/[clinicId]/status' as const, query: { clinicId }, hash: url?.hash })
      }
    })
  },
  $url: (url?: { hash?: string }) => ({ pathname: '/' as const, hash: url?.hash })
}

export type PagesPath = typeof pagesPath
